function priceToggleModule() {
    this.listen = function () {
        $("[data-switch-checked]").on("click", function () {
            var $this = $(this);
            var selector = $this.attr("data-switch-selector");
            var checked = $this.attr("data-switch-checked");

            $(selector).prop("checked", checked === "true");
            $(selector).trigger("change");
        });

        $(".price-toggle").on("change", function () {
            var $this = $(this);
            var attribute_selector =
                $this.prop("checked") === true
                    ? "data-switch-true"
                    : "data-switch-false";

            var value_to_show = $this.attr(attribute_selector);

            $("[" + value_to_show + "]").each(function () {
                $(this).html($(this).attr(value_to_show));
            });
        });
    };
}

module.exports = priceToggleModule;
